<section class="searchbar">

    <div class="cab-form" style="z-index: 100;">

        <!-- افزودن سفر -->

        <div class="mails_list">

            <div class="d-flex justify-content-center">

                <div class="write_mail w-100">

                    <form [formGroup]="mdl_TripSAD" class="modal-body p-2">

                        <ng-container>

                            <div class="central mb-2 form_box">

                                <!-- <label class="text-muted m-0"> شهر مبدا </label> -->

                                <div class="position-relative w-75 mb-md-0 mb-2">


                                    <custom-filter
                                        [strValue]="returnStrValue('strSCity',mdl_TripSAD.get('strSCity')?.value,list_City,'strCityName')"
                                        [strComment]="'strCityName'"
                                        [stylesArray]="['padding-top: 10px','text-align: center']"
                                        [str_Placeholder]="'شهر مبداء را مشخص کنید'" [lst_Main]="list_City"
                                        [lst_SearchKey]="['strCityName']" [isDisabled]="false"
                                        (hideOptions)="setValue_filter('strSCity',$event)">


                                    </custom-filter>

                                </div>

                                <div class="mx-1 w-auto text-center">

                                    <img style="width:40px;rotate: 180deg;" src="../../../assets/imgs/3248150.png"
                                        alt="">

                                </div>

                                <!-- <label class="text-muted m-0"> شهر مقصد </label> -->

                                <div class="position-relative w-75 ">

                                    <custom-filter
                                        [strValue]="returnStrValue('strDCity',mdl_TripSAD.get('strDCity')?.value,list_City,'strCityName')"
                                        [strComment]="'strCityName'"
                                        [stylesArray]="['padding-top: 10px','text-align: center']"
                                        [str_Placeholder]="'شهر مقصد خود را مشخص کنید'" [lst_Main]="list_City"
                                        [lst_SearchKey]="['strCityName']" [isDisabled]="false"
                                        (hideOptions)="setValue_filter('strDCity',$event)">

                                    </custom-filter>

                                </div>

                            </div>

                            <div [formGroup]="mdl_TripSAD" class="central home_options mb-3">

                                <!-- اقتصادی -->

                                <div class="central justify-content-start my-1">
                                    <label class="radio-label" for="furnished-0">
                                        <input type="radio" id="furnished-0" formControlName="tiMobileGroup" [value]="1"
                                            style="display: none;">
                                        <img class="fill" src="../../../assets/imgs/car-sedan-fill.png"
                                            alt="خودرو اقتصادی برای سفر بین شهر">
                                        <img class="nofill" src="../../../assets/imgs/car-sedan.png"
                                            alt="خودرو اقتصادی برای سفر بین شهر">
                                        <p>اقتصادی</p>
                                    </label>
                                </div>

                                <!-- اقتصادی ویژه -->

                                <div class="central justify-content-start my-1">
                                    <label class="radio-label" for="furnished-5">
                                        <input type="radio" id="furnished-5" formControlName="tiMobileGroup" [value]="2"
                                            style="display: none;">
                                        <img class="fill" src="../../../assets/imgs/eco-fill.png"
                                            alt="خودرو اقتصادی با کیفیت بالا برای سفر بین شهر">
                                        <img class="nofill" src="../../../assets/imgs/car-eco.png"
                                            alt="خودرو اقتصادی با کیفیت بالا برای سفر بین شهر">
                                        <p>اقتصادی ویژه</p>
                                    </label>
                                </div>

                                <!-- ماشین اختصاصی -->

                                <div class="central justify-content-start my-1">

                                    <label class="radio-label" for="furnished-1">

                                        <input type="radio" id="furnished-1" formControlName="tiMobileGroup" [value]="3"
                                            style="display: none;">

                                        <img class="fill" src="../../../assets/imgs/car-lux-fill.png"
                                            alt="تاکسی لوکس بین شهری ">

                                        <img class="nofill" src="../../../assets/imgs/car-lux.png"
                                            alt="تاکسی لوکس بین شهری ">

                                        <p> لوکس</p>

                                    </label>

                                </div>

                                <!-- SUV -->

                                <div class="central justify-content-start my-1">
                                    <label class="radio-label" for="furnished-2">
                                        <input type="radio" id="furnished-2" formControlName="tiMobileGroup" [value]="4"
                                            style="display: none;">
                                        <img class="fill" src="../../../assets/imgs/suv-car-fill.png"
                                            alt="خودرو شاسی بلند برای سفر بین شهر">
                                        <img class="nofill" src="../../../assets/imgs/suv-car.png"
                                            alt="خودرو شاسی بلند برای سفر بین شهر">
                                        <p>SUV</p>
                                    </label>
                                </div>

                                <!-- ون و مینی‌ون -->

                                <div class="central justify-content-start my-1">
                                    <label class="radio-label" for="furnished-3">
                                        <input type="radio" id="furnished-3" formControlName="tiMobileGroup" [value]="5"
                                            style="display: none;">
                                        <img class="fill" src="../../../assets/imgs/car-van-fill.png"
                                            alt="ون و مینی‌ون">
                                        <img class="nofill" src="../../../assets/imgs/car-van.png"
                                            alt="کرایه ون -کرایه مینی بوس – کرایه اتوبوس">
                                        <p>ون و مینی‌ون</p>
                                    </label>
                                </div>

                            </div>

                            <div *ngIf="list_PreOrder.fKm"
                                class=" central w-100 my-2 flex-column justify-content-between form_box">

                                <!-- محاسبه هزینه -->

                                <div class="alert alert-primary w-100 row gx-0 gy-2 gy-md-0" role="alert">

                                    <!-- مدت زمان -->

                                    <div class="col-12 col-md-auto ps-md-3">

                                        مدت : <b>{{list_PreOrder.strTime | faNum}} </b>

                                    </div>

                                    <!-- مسافت تقریبی -->

                                    <div class="col-12 col-md-auto ps-md-3">
                                        مسافت تقریبی : <b> {{list_PreOrder.fKm | faNum}} کیلومتر </b>
                                    </div>

                                    <!-- برآورد اولیه -->

                                    <div class="col-12 col-md-auto ps-md-3">

                                        برآورد اولیه : <b>{{list_PreOrder.iRent | number: '1.0-0' | faNum}} ریال</b>

                                    </div>

                                </div>

                                <div *ngIf="list_PreOrder?.iDiscount"
                                    class="alert alert-danger w-100 row gx-0 gy-2 gy-md-0" role="alert">

                                    <div class="col-12">

                                        این سفر شامل

                                        <b> {{ list_PreOrder.iDiscount | number:'1.0-0' | faNum}} ریال </b>

                                        تخفیف می باشد.

                                    </div>

                                </div>

                                <!-- متن ثبت سفر -->

                                <div class="alert alert-success w-100 m-0 py-0">

                                    <h3 style="margin-bottom: 0!important;">

                                        همین الان سفر خود را از <strong> {{
                                            returnStrValue('strCity',mdl_TripSAD.get('strSCity')?.value,list_City,'strCityName')
                                            }} </strong> به <strong> {{
                                            returnStrValue('strCity',mdl_TripSAD.get('strDCity')?.value,list_City,'strCityName')
                                            }} </strong> در تاکسی لون ثبت کنید.

                                    </h3>

                                </div>

                            </div>

                            <div class="central w-100 flex-column align-items-start price_offer">

                                <div class="row gx-0 gy-2 gy-md-0 my-2 w-100">

                                    <!-- محاسبه هزینه -->

                                    <div class="col-12 col-md-auto px-md-1">

                                        <button (click)="serviceCalc()" class="w-100 btn btn-third px-4">

                                            محاسبه هزینه

                                        </button>

                                    </div>

                                    <!-- رزرو تاکسی بین شهری  -->

                                    <div class="col-12 col-md-auto px-md-1">

                                        <button *ngIf="!isLogin" (click)="login('NewTrip')"
                                            class="w-100 btn btn-primary px-4">

                                            رزرو تاکسی بین شهری

                                        </button>

                                        <button *ngIf="isLogin" routerLink="/taxilon/NewTrip"
                                            class="w-100 btn btn-primary px-4">

                                            رزرو تاکسی بین شهری

                                        </button>

                                    </div>

                                    <!-- نمایش مسیر سفر -->

                                    <div class="col-12 col-md-auto px-md-1">
                                        <button *ngIf="isRoute_Hide()" [disabled]="useOfflineMap"
                                            class="w-100 btn btn-success px-4" (click)="openRoute()">
                                            نمایش مسیر سفر
                                        </button>
                                    </div>

                                    <app-custom-map *ngIf="isRoute_Hide() && bRouteModal" [isOpenModal]="true"
                                        [isDrawRoute]="true" [isShowAll]="false"
                                        [objRoute]="mdl_TripSAD.get('ObjResponse')?.value"
                                        [sLonLat]="[mdl_TripSAD.get('fSLon')?.value,mdl_TripSAD.get('fSLat')?.value]"
                                        [dLonLat]="[mdl_TripSAD.get('fDLon')?.value,mdl_TripSAD.get('fDLat')?.value]"
                                        [strValue]="' مسیر ' + mdl_TripSAD.get('strSCityName')?.value + ' به ' + mdl_TripSAD.get('strDCityName')?.value "
                                        (mdl_Submit)="bRouteModal = false ">

                                    </app-custom-map>

                                </div>

                                <div *ngIf="strHelp != '' " class="alert alert-secondary w-100  mb-0 mt-3 text-center ">

                                    <span style="font-size: 13px!important;">

                                        {{ strHelp | faNum }}

                                    </span>

                                </div>

                            </div>

                        </ng-container>

                    </form>

                </div>

            </div>

        </div>

    </div>

    <img src="../../../assets/imgs/Search-bar.png" alt="جستجو دیار">

    <div class="search-inner"></div>

</section>

<main class="main-container">

    <!-- کسب درآمد از سفرهای بین شهری  -->
    <section class="marketers mb-5 row gx-0 gy-0">
        <div class="col-md-12 my-4 central">
            <div class="container text-center">
                <div class="img-container text-center my-4">
                    <img width="128px" src="../../../assets/imgs/earnings.png" alt="کسب درآمد از سفرهای بین شهری">
                </div>
                <h2 class="fw-bold"> کسب درآمد از سفرهای بین شهری </h2>
                <p style="line-height: 40px;font-size: 15px;">
                    تاکسی لون به شما این امکان را می‌دهد تا به جای استفاده از روش‌های سنتی برای اعزام خودرو، سفرهای خود
                    را به صورت آنلاین ثبت کنید، خدماتی به‌روز به مسافران خود ارائه دهید و از هر سفر کمیسیون مناسبی
                    دریافت کنید.
                    همچنین، این سامانه به رانندگان کمک می‌کند تا درآمد بیشتری کسب کرده و بهره‌وری خود را افزایش دهند.
                </p>

                <button class="btn btn-primary px-5 mb-2 ">
                    <a href="/partners" target="_blank">
                        اطلاعات بیشتر
                    </a>
                </button>
            </div>
        </div>
    </section>

    <!-- تاکسی بین شهری -->
    <section class="intercity-taxi w-100 my-4">

        <div class="row gx-0 gy-0 w-100">

            <div class="col-md-6 col-0"> </div>

            <div class="container col-md-6 col-12 p-md-2 p-3">

                <h1 class="fw-bold"> تاکسی بین‌شهری، راحت‌ترین راه سفر </h1>

                <p class="" style="line-height: 37px;font-size: 15px;">

                    اگر به دنبال روشی آسان، سریع و مطمئن برای سفر بین شهرهای مختلف هستید، خدمات تاکسی بین شهری بهترین
                    گزینه برای شماست. این خدمات به شما این امکان را می‌دهد که بدون دغدغه‌های رانندگی، خستگی سفر و
                    نگرانی‌های مربوط به تأخیر وسایل نقلیه عمومی، به مقصد خود برسید.

                </p>

                <div class="col-12">

                    <button class="btn btn-primary px-5 mb-2 ">

                        <a href="/taxilon/intercity-taxi" target="_blank"> اطلاعات بیشتر &zwnj; </a>

                    </button>

                </div>


            </div>

        </div>

    </section>

    <!-- آگهی های مرتبط با حمل و نقل و سفر -->
    <section class="marketers my-5 row gx-0 gy-0" #adsContainer>

        <div *ngIf="obj_AppInfo?.bJobs" class="col-md-12 my-4 central">

            <div class="container text-center">

                <div class="img-container text-center my-4">

                    <img width="128px" src="../../../assets/imgs/hiring.png" alt="آگهی های آماده به کار،استخدام راننده">

                </div>

                <h2 class="fw-bold"> آگهی های مرتبط با حمل و نقل و سفر </h2>

                <p style="line-height: 40px;font-size: 15px;">

                    در این بخش از تاکسی لون، می‌توانید آگهی‌های ثبت‌ شده توسط رانندگان برای ارائه خدمات متنوع مانند
                    سفرهای ساعتی، ماهیانه، یا کلید در اختیار و یا نیاز نیازمندهای حمل نقل شرکت ها و سازمان ها را مشاهده
                    کنید.

                </p>

                <ng-container *ngIf="lst_NewAds.length > 0">

                    <owl-carousel-o [options]="carouselOptions4News">

                        <ng-template *ngFor="let item of lst_NewAds" carouselSlide>

                            <div class="p-2 h-100" (click)="showAds(item)">

                                <div class="adds_box border border-2 h-100 p-1">

                                    <div class="img_box">

                                        <img src="{{item.strImage != '' ? 'data:image/png;base64,' + item.strImage : '../../../assets/imgs/preview__thumbnail.png'}}"
                                            [title]="item.strTitle" alt="{{item.strTitle}}">

                                    </div>

                                    <div class="detail_box w-100 h-100" style="max-height: 70px!important;">

                                        <h3 class="fw-bold mx-0 mb-1 text-end" style="font-size: 13px;">
                                            {{subString_Title(item.strTitle,27) | faNum}}</h3>

                                        <div class="text-end">

                                            <span class="text-muted" style="font-size: 13px;">

                                                {{ item.strPublishTime }} در {{ item.strCityName }}

                                            </span>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </ng-template>

                    </owl-carousel-o>

                </ng-container>

                <button class="btn btn-primary px-5 my-2 ">

                    <a href="/taxilon/jobs" target="_blank">

                        مشاهده آگهی&zwnj;ها

                    </a>

                </button>

            </div>

        </div>

    </section>

    <!-- رانندگان -->
    <section class="drivers-container my-4 about central justify-content-start">

        <div class="">

            <h2 style="font-size: 27px;"> به جمع رانندگان تاکسی بین شهری تاکسی لون بپیوندید! </h2>

            <p style="line-height: 37px;font-size: 15px;">

                اگر به دنبال یک پلتفرم حرفه‌ای، مطمئن و کارآمد برای ارائه خدمات حمل‌ونقل بین‌شهری هستید، تاکسی لون
                انتخابی ایده‌آل برای شماست. با پیوستن به خانواده تاکسی لون، از خدمات و مزایای بی‌نظیری بهره‌مند شوید که
                تجربه شما را به سطحی جدید ارتقا می‌بخشد.

                پس همین حالا به جمع خانواده بزرگ تاکسی لون بپیوندید!
            </p>

            <button class="btn btn-primary px-5 mb-2 ">

                <a href="/taxilon/drivers" target="_blank">

                    اطلاعات بیشتر&zwnj;

                </a>

            </button>

        </div>

    </section>

    <!-- نظرات کاربران -->
    <section class="feedback-container p-3 my-5" #feedbackContainer>
        <div *ngIf="obj_AppInfo?.bPassengerExperience" class="container">
            <div class="central sec_title mb-2">
                <h2 style="font-size: 22px;"> تجربه مسافرین با تاکسی‌لون
                    <span *ngIf="lst_Feedback.length" style="font-size: 15px;">
                        ({{ lst_Feedback.length | number:'1.0-0' | faNum }})
                    </span>
                </h2>
            </div>
            <div class="row gx-0 gy-2 p-2">
                <owl-carousel-o [options]="carouselOptions">
                    <ng-template *ngFor="let item of lst_Feedback" carouselSlide>
                        <div class="feedback-user w-100 p-2">
                            <div class="w-100 h-100 border border-2">
                                <div class="feedback-header row gx-0 gy-0 w-100 border-bottom border-2 p-2">
                                    <div class="col-3 feedback-avatar">
                                        <img src="{{item.strAvatar != '' ? 'data:image/png;base64,' + item.strAvatar : '../../../assets/imgs/avatar-default-icon.png' }}"
                                            alt="تصویر کاربر">
                                    </div>
                                    <span class="feedback-name pe-2 col-6"> {{ item.strName | faNum }} </span>
                                    <span dir="ltr" class="feedback-point col-3">
                                        <b style="font-size: 17px;">{{ item.tiDriverPoints | faNum}}</b>/{{'5' | faNum
                                        }}
                                    </span>
                                </div>
                                <div class="feedback-body">
                                    <article class="p-3">
                                        <span style="line-height: 25px;font-size: 12px;"> {{ item.strPassengerOpinion |
                                            faNum }} </span>
                                    </article>
                                </div>
                                <div class="feedback-footer px-2 border-top border-2">
                                    <star-rating [starType]="'svg'" [rating]="item.tiDriverPoints" [size]="'small'">
                                    </star-rating>
                                    <span> {{ item.strDate | faNum}} </span>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>


    </section>

    <!-- تعرفه ها -->
    <section *ngIf="obj_AppInfo?.bIntercityTaxiPrice" class="py-5">

        <div class="central sec_title mb-2">

            <h2 class="fw-bold"> قیمت تاکسی بین شهری </h2>

        </div>

        <div class="container">

            <div class="row">

                <div class="col-lg-1 col-12 my-1">

                </div>

                <!-- اقتصادی -->

                <div class="col-lg-2 col-6 my-1">

                    <div class="price_box">

                        <div class="image">
                            <img src="../../../assets/imgs/Dena.png" class="full-width"
                                alt="خودرو اقتصادی برای سفر بین شهر">
                        </div>

                        <h3>اقتصادی</h3>

                        <p> خودرو هایی از قبیل پژوپارس ، سمند ، دنا و ...</p>

                        <div class="price_detail">{{ lst_TaxiPrice[0]?.iRent | number: '1.0-0' | faNum }} ریال<span> /
                                km </span></div>

                    </div>

                </div>

                <!-- اقتصادی ویژه -->

                <div class="col-lg-2 col-6 my-1">
                    <div class="price_box">
                        <div class="image">
                            <img src="../../../assets/imgs/ario.png" class="full-width"
                                alt="خودرو اقتصادی با کیفیت بالا برای سفر بین شهر">
                        </div>
                        <h3>اقتصادی ویژه</h3>
                        <p> خودرو هایی از قبیل آریو ، برلیانس و دنا پلاس و ...</p>
                        <div class="price_detail">{{lst_TaxiPrice[1]?.iRent | number: '1.0-0' | faNum }} ریال<span> / km
                            </span></div>
                    </div>
                </div>

                <!-- ماشین اختصاصی -->

                <div class="col-lg-2 col-6 my-1">
                    <div class="price_box">
                        <div class="image">
                            <img src="../../../assets/imgs/Sonata.png" class="full-width" alt="تاکسی لوکس بین شهری ">
                        </div>
                        <h3> لوکس</h3>
                        <p> خودرو هایی از قبیل سوناتا، کمری،BMW پریوس و ...</p>
                        <div class="price_detail">{{lst_TaxiPrice[2]?.iRent | number: '1.0-0' | faNum }} ریال<span> / km
                            </span></div>
                    </div>
                </div>

                <!-- شاسی بلند -->

                <div class="col-lg-2 col-6 my-1">
                    <div class="price_box">
                        <div class="image">
                            <img src="../../../assets/imgs/Rav4.png" class="full-width"
                                alt="شاسی بلند برای سفر بین شهر">
                        </div>
                        <h3>SUV</h3>
                        <p> خودرو هایی از قبیل ویتار، رافور، سورنتور، توسان و ...</p>
                        <div class="price_detail">{{lst_TaxiPrice[3]?.iRent | number: '1.0-0' | faNum }} ریال<span> / km
                            </span></div>
                    </div>
                </div>

                <!-- ون -->

                <div class="col-lg-2 col-6 my-1">
                    <div class="price_box">
                        <div class="image">
                            <img src="../../../assets/imgs/Haice.png" class="full-width"
                                alt="کرایه ون -کرایه مینی بوس – کرایه اتوبوس">
                        </div>
                        <h3>ون</h3>
                        <p> خودرو هایی از قبیل هیوندای، هایس، وانا و ...</p>
                        <div class="price_detail">{{lst_TaxiPrice[4]?.iRent | number: '1.0-0' | faNum }} ریال<span> / km
                            </span></div>
                    </div>
                </div>

                <div class="col-lg-1 col-12 my-1">

                </div>

            </div>

        </div>

    </section>

    <!-- ناوگان تاکسی لون -->
    <section class="fleet-container p-md-3 py-3 px-4 my-5" #fleetContainer>
        <div *ngIf="obj_AppInfo?.bCurrentDriversLocation" class="container h-100">
            <div class="central sec_title mb-2">
                <h3> موقعیت فعلی ناوگان تاکسی‌لون </h3>
            </div>
            <app-custom-map *ngIf="lst_Drivers.length > 0" [isShowAll]="true"
                [MARKER_ICON]="'../../../assets/imgs/taxi.png'" [lst_Array]="lst_Drivers" [lat_StrKey]="'dLatitude'"
                [lon_StrKey]="'dLongitude'" [stylesArray]="['width: 100%','height: 500px','margin-bottom: 20px']">
            </app-custom-map>
        </div>
    </section>

    <!-- اخبار و جاذبه‌های گردشگری -->
    <section [ngClass]="news.length > 0 ? 'py-3' : ''" #EventContainer>

        <div *ngIf="obj_AppInfo?.bNews" class="container">

            <ng-container *ngIf="news.length > 0">

                <div class="central sec_title my-5">

                    <h3> اخبار و جاذبه‌های گردشگری </h3>

                </div>

                <owl-carousel-o [options]="carouselOptions4News">

                    <ng-template *ngFor="let item of news" carouselSlide>

                        <div (click)="openNews(item?.iNews)" class="p-2 h-100">

                            <div class="adds_box h-100">

                                <div class="img_box">

                                    <img *ngIf="item.strImage" src="data:image/png;base64,{{item.strImage}}"
                                        [title]="item.strTitle" alt="{{item.strTitle}}">

                                    <img *ngIf="!item.strImage" src="../../../assets/imgs/preview__thumbnail.png"
                                        alt="{{item.strTitle}}">

                                </div>

                                <div class="detail_box w-100 h-100" style="max-height: 70px!important;">

                                    <h3 class=" fw-bold mx-0 mb-1" style="font-size: 13px;">
                                        {{subString_Title(item.strTitle,60) | faNum}}</h3>

                                    <div class="text-start">

                                        <span class="text-muted" style="font-size: 13px;">{{
                                            item.strValidateDateAndTime}}</span>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </ng-template>

                </owl-carousel-o>

                <div class="central">

                    <button class="btn btn-primary btn-title my-3 ">

                        <a href="/taxilon/news" target="_blank"> مشاهده بیشتر </a>

                    </button>

                </div>

            </ng-container>

        </div>

    </section>

    <!-- محتواهای آموزشی -->
    <section [ngClass]="lst_Educations.length > 0 ? 'p-3 my-5' : ''" #EducationContainer>

        <article *ngIf="obj_AppInfo?.bProfessionalTraining" class="container">

            <div class="row gx-0 gy-2">

                <div class="central sec_title my-5">

                    <h3> محتواهای آموزشی</h3>

                </div>

                <owl-carousel-o [options]="carouselOptions4News">

                    <ng-template *ngFor="let item of lst_Educations" class="col-md-4 col-12 p-3" carouselSlide>

                        <div class="card w-100">

                            <div class="video-container">

                                <iframe class="responsive-iframe" [src]="item.strContentPath" allowFullScreen="true"
                                    webkitallowfullscreen="true" mozallowfullscreen="true">

                                </iframe>

                            </div>

                            <div class="card-body">

                                <h4 class="card-title mb-1" style="height:51px;"> {{ subString_Title(item.strTitle,63) |
                                    faNum }} </h4>

                                <p class="card-text text-muted" style="height: 70px;"> {{
                                    subString_Title(item.strDetail,90) | faNum}} </p>

                            </div>

                        </div>

                    </ng-template>

                </owl-carousel-o>

                <div class="central">

                    <button class="btn btn-primary btn-title my-3 ">

                        <a href="/taxilon/educations" target="_blank"> مشاهده بیشتر </a>

                    </button>

                </div>

            </div>

        </article>

    </section>

</main>

<!-- فوتر  -->
<app-footer></app-footer>

<!-- تبلیغات -->
<div class="modal  fade dir " id="modal" tabindex="4" role="dialog" style="z-index:100000 !important;">

    <div style="width:90%;" class="modal-dialog modal-lg modal-dialog-centered">

        <div class="modal-content bg-gray-soft">

            <div class="modal-body p-0 ">

                <button type="button" class="btn-close m-0 btn_close" data-bs-dismiss="modal"
                    aria-label="Close"></button>

                <div class="w-100 h-100">

                    <a class="w-100" target="_blank" href="{{popAds?.strURL}}"
                        (click)="popupClick(popAds.iDyar_PopupADV)">

                        <img class="w-100" src="data:image/png;base64,{{popAds?.strIMage}}" alt="{{popAds?.strTitle}}">

                    </a>

                </div>

            </div>

        </div>

    </div>

</div>